import React from 'react';
import { cn } from '../../../utils/cn';
import {
  buildEmptyIpr,
  computeIprTotal,
  countContactsWithIpr,
  IPR_TOOL_SELECT,
} from '../../../lib/iprToothData';
import PatientInfoSection from './PatientInfoSection';
import DentalDiagram from './DentalDiagram';
import IPRInstructionsTable from './IPRInstructionsTable';

const CLINICAL_NOTES = [
  'Utiliser des strips diamantés pour la réduction inter-proximale',
  'Respecter les mesures indiquées avec précision (±0.05mm)',
  'Respecter la mesure de chaque contact ; le côté d’attaque est choisi au fauteuil',
  'Polir les surfaces après réduction pour limiter la plaque',
  'Scanner le QR code en en-tête pour la traçabilité du stripping',
];

/**
 * Corps unique de la fiche IPR (page, modal jalon, aperçu atelier).
 * Contient diagramme + outils (bouton / attachements / …) + table + notes.
 */
export default function IprSheetBody({
  iprData,
  selectedTooth = null,
  onToothSelect,
  activeTool = IPR_TOOL_SELECT,
  onToolChange,
  onToggleMarker,
  onIPRUpdate,
  readOnly = false,
  variant = 'default',
  patientData = null,
  showPatientHeader = false,
  showClinicalNotes = true,
  className = '',
}) {
  const data = iprData || buildEmptyIpr();
  const totalIPR = computeIprTotal(data);
  const contactsWithIpr = countContactsWithIpr(data);

  return (
    <div
      className={cn(
        'ipr-sheet-shell print:shadow-none print:border-0 bg-white overflow-hidden',
        className
      )}
    >
      {showPatientHeader && patientData && (
        <PatientInfoSection
          patientData={patientData}
          totalIPR={totalIPR}
          contactsWithIpr={contactsWithIpr}
        />
      )}

      <DentalDiagram
        iprData={data}
        selectedTooth={selectedTooth}
        onToothSelect={onToothSelect}
        activeTool={activeTool}
        onToolChange={onToolChange}
        onToggleMarker={onToggleMarker}
        readOnly={readOnly}
        variant={variant}
      />

      <IPRInstructionsTable
        iprData={data}
        onIPRUpdate={onIPRUpdate}
        selectedTooth={selectedTooth}
        onToothSelect={onToothSelect}
        activeTool={activeTool}
        readOnly={readOnly}
      />

      {showClinicalNotes && (
        <div className="border-t border-gray-200/80 p-4 md:p-5 ipr-section-surface">
          <h3 className="font-semibold text-gray-900 mb-2 text-sm">Instructions importantes</h3>
          <ul className="text-xs text-gray-600 space-y-1.5 columns-1 md:columns-2 gap-6">
            {CLINICAL_NOTES.map((item) => (
              <li key={item} className="flex items-start break-inside-avoid">
                <span className="text-primary mr-2">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
